<template>
  <div class="nacha-bank-info container">
    <h4>Bank Information on Nacha</h4>
    <div class="row">
      <amf-info :label="'Routing Number'" v-model="bankInfo.nachaRouting" />
      <amf-info :label="'Account Number'" v-model="bankInfo.nachaAccount" />
    </div>
    <h4>Current Bank Account Information</h4>
    <div class="row">
      <amf-info :label="'Routing Number'" v-model="bankInfo.currentRouting" />
      <amf-info :label="'Account Number'" v-model="bankInfo.currentAccount" />
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { toastService } from '../framework/utils/toast-service';

export default {
  data() {
    return {
      bankInfo: [],
    };
  },
  props: ["participantId", "bankTransferId", "title","readOnly"],
  computed: {
    buttons() {
      return "Close";
    },
    buttonsCustom() {
        if(!this.readOnly) return "$Use Current Bank Info and Renacha";
    },

  },
  methods: {
    async load() {
      this.bankInfo = await romeApi.get(
        `participant/nacha/${this.participantId}/bankinfo/${this.bankTransferId}`
      );
    },
    async useCurrentBankInfoAndRenacha() {
        var data = {
            bankTransferId: this.bankTransferId,
            currentRouting: this.bankInfo.currentRouting,
            currentAccount: this.bankInfo.currentAccount
        };

        let res =  await romeApi.post("participant/nacha/renacha", data);
        if(res.success)
        {
          toastService.success("Payment Requeued.");
        }
        else
        {
          toastService.error(res.message);
        }

        return true;
    },
  },
  created() {
    this.load();
  },
};
</script>




// WEBPACK FOOTER //
// src/finance/BankInfo.vue